import styled from 'styled-components';
import {
  maxMobile,
  maxWidth, retina,
} from 'Utils/utilsStyle';
import { Row, Col } from 'antd';

import IndustriesSkeleton from 'Components/common/skeleton/IndustriesSkeleton';

const StyleWrapper = styled.div`
  padding-bottom: 70px;
  .fancy-box {
    border-radius: 10px;
    box-shadow: 0 0 60px rgba(0, 0, 0, 0.14);
    background: rgb(255, 255, 255);
    padding: 40px 50px 40px 50px;
    margin-top: 50px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     padding: 17px 25px 25px 25px;
    }
    @media all and (max-width: ${maxMobile}) {
     padding: 17px 16px 16px 16px;
    }
  }
  .industriesSection {
    margin-top: 20px;
    .search-distance-row{
      margin: 0 !important;
    }
  }
`;

const IndustriesSectionSkeleton = function IndustriesSectionSkeleton() {
  const getCompaniesLoadingSkeleton = () => {
    const skeletons = [];
    for (let i = 0; i < 6; i += 1) {
      skeletons.push(
        <Col span={4} className="gutter-row">
          <IndustriesSkeleton />
        </Col>,
      );
    }
    return (
      skeletons
    );
  };

  return (
    <StyleWrapper>
      <div className="fancy-box">
        <div className="industriesSection">
          <Row className="Grid-width-row" gutter={[24, 24]}>
            {getCompaniesLoadingSkeleton()}
          </Row>
        </div>
      </div>
    </StyleWrapper>
  );
};
export default IndustriesSectionSkeleton;
